var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.match` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.match.js
// module id = 466
// module chunks = 3